import { SummaryStatisticsTableCell } from 'modules/mailing/email-statistics/components/summary-statistics-table/summary-statistics-table-cell'
import { SummaryStatistics } from 'modules/mailing/email-statistics/types/email-statistics-interface'
import { getStatistic } from 'modules/mailing/email-statistics/utils/get-statistic'
import { TextWithTooltipCell } from 'shared/components/table/cells/text-with-tooltip-cell'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const SummaryStatisticsTable = ({
  isLoading,
  summaryStatistics,
}: {
  isLoading: boolean
  summaryStatistics?: SummaryStatistics
}) => {
  const { t } = useLocoTranslation()

  const { clicksRate, openRate, spamReportRate, bouncedRate } = getStatistic(summaryStatistics)

  return (
    <div
      className={`mb-5 grid w-full grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4 ${
        isLoading ? 'animate-pulse' : ''
      }`}
    >
      <SummaryStatisticsTableCell
        label={t('dashboard.email_statistics.summary_statistics.open_rate')}
        value={<TextWithTooltipCell>{openRate}</TextWithTooltipCell>}
        isLoading={isLoading}
      />
      <SummaryStatisticsTableCell
        label={t('dashboard.email_statistics.summary_statistics.spam_report_rate')}
        value={<TextWithTooltipCell>{spamReportRate}</TextWithTooltipCell>}
        isLoading={isLoading}
      />
      <SummaryStatisticsTableCell
        label={t('dashboard.email_statistics.summary_statistics.clicks_rate')}
        value={<TextWithTooltipCell>{clicksRate}</TextWithTooltipCell>}
        isLoading={isLoading}
      />
      <SummaryStatisticsTableCell
        label={t('dashboard.email_statistics.summary_statistics.bounced_rate')}
        value={<TextWithTooltipCell>{bouncedRate}</TextWithTooltipCell>}
        isLoading={isLoading}
      />
    </div>
  )
}
